module.exports = __webpack_public_path__ + "img/credential.cdfb808e.svg";